import { loadFromStorage, saveToStorage } from "app/assets/javascripts/utils/localstorage"
import { getDateNow } from "app/assets/javascripts/utils/date"
import logEvent from "app/assets/javascripts/tracking/amplitude/log-event"
import scribdAuthorize from "app/assets/javascripts/scribd/scribd_oauth.js"
import { player } from "app/assets/javascripts/new_player/selectors"

export const ALLOWED_CONTENT_COUNT_WITHOUT_SUBSCRIPTION = 1
const LOCAL_STORAGE_KEY = "contentGateV3"
// Only count documents seen in the last 30 days. The value is in milliseconds
const PERIOD_TO_LOOK_BACK = 30 * 24 * 60 * 60 * 1000
/**
 * code around this feature was built with the assumption that we would always show
 * the banner before showing view restriction, it is a negative integer as we want to
 * show the banner & view restriction at the same time.
 */
export const CONTENT_COUNT_TO_START_RENDERING_BANNER_NOTIFICATIONS = -1

const hasValidId = (id) => !!id && typeof id === "string"
const hasValidDate = (dateTime) => !!dateTime && getIsValidIsoDate(dateTime)

export const getContentGateDataFromStorage = () => {
  let state = loadFromStorage(LOCAL_STORAGE_KEY)
  if (!Array.isArray(state.documents)) {
    state.documents = []
  }
  return state.documents
}

export const isRevisit = (slideshowId) => {
  const contentGateData = getContentGateDataFromStorage()
  const foundIndex = contentGateData.findIndex((item) => item.id === slideshowId)
  return foundIndex > -1 && contentGateData[foundIndex].revisitAllowed
}

export const trackView = (id) => {
  let contentGateData = getContentGateDataFromStorage()

  const expiredTimestamp = new Date(getDateNow().getTime() - PERIOD_TO_LOOK_BACK).toISOString()

  contentGateData = contentGateData.filter(isValidEntry).filter((d) => d.at > expiredTimestamp)

  const foundIndex = contentGateData.findIndex((item) => item.id === id)

  if (foundIndex === -1) {
    if (contentGateData.length >= ALLOWED_CONTENT_COUNT_WITHOUT_SUBSCRIPTION) {
      contentGateData.push({ id: id, at: getDateNow(), revisitAllowed: false })
    } else {
      contentGateData.push({ id: id, at: getDateNow(), revisitAllowed: true })
    }
  }

  saveToStorage(LOCAL_STORAGE_KEY, { documents: contentGateData })
  return contentGateData.length
}

export const getIsValidIsoDate = (dateStr) => {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(dateStr)) {
    return false
  } else {
    return new Date(dateStr).toISOString() === dateStr
  }
}

function isValidEntry(entry) {
  return hasValidId(entry.id) && hasValidDate(entry.at)
}

export const getShouldShowBannerNotificationsUX = (
  allowedContentCount,
  contentAccountGateDataLength,
  contentCountWithoutBannerNotifications
) => {
  return allowedContentCount - contentAccountGateDataLength <= contentCountWithoutBannerNotifications
}

export const getShouldShowReaderBlur = (contentAccountGateDataLength) => {
  return contentAccountGateDataLength > ALLOWED_CONTENT_COUNT_WITHOUT_SUBSCRIPTION
}

export const logViewRestrictionEvent = (contentViewedCount) => {
  const isShowingBannerForFirstTime =
    contentViewedCount ===
    ALLOWED_CONTENT_COUNT_WITHOUT_SUBSCRIPTION - CONTENT_COUNT_TO_START_RENDERING_BANNER_NOTIFICATIONS
  // UX restriction is applied for the first time on the 2nd view
  const isShowingRestrictionForFirstTime = contentViewedCount === ALLOWED_CONTENT_COUNT_WITHOUT_SUBSCRIPTION + 1

  if (isShowingBannerForFirstTime) {
    logEvent("view_restriction_banner_shown")
  }

  if (isShowingRestrictionForFirstTime) {
    logEvent("view_restriction_threshold_hit")
  }
}

const getBannerNotificationText = (remainingDocCount, slideshare_object) => {
  const utils = slideshare_object.utils
  if (getShouldShowReaderBlur(remainingDocCount)) {
    return utils.i18n("slideshow.foundation_slideview.limit_content_without_account.notification_banner_ran_out_text")
  }
}

const handleScribdAuthorize = () => {
  const slideshare_object = window.slideshare_object
  const slideshow = slideshare_object && slideshare_object.slideshow
  scribdAuthorize({
    from_source: `${slideshow.ss_url}?subscription_success_banner=show`,
    slideshow_id: slideshow.id,
    isContentGate: true,
  })
}

export const handleBannerNotification = (remainingDocCount, slideshare_object) => {
  const $banner = $(".limit-notification")
  const $notificationWarningtextElem = $banner.find("#notification-warning-text")
  $notificationWarningtextElem.empty()
  $notificationWarningtextElem.append(getBannerNotificationText(remainingDocCount, slideshare_object))
  $banner.find("#notification-warning-link").on("click", handleScribdAuthorize)
  $banner.css("opacity", 0).slideDown(400).animate({ opacity: 1 }, { queue: false, duration: 400 })
}

export const showLimitOverlay = () => {
  const $limitOverlay = $(".limit-overlay")
  $limitOverlay.find("#sign-up-with-scribd").on("click", handleScribdAuthorize)
  $limitOverlay.css("display", "")
  player.addClass("guest-limit")
}

export const hideLimitOverlay = () => {
  const $limitOverlay = $(".limit-overlay")
  $limitOverlay.css("display", "none")
  player.removeClass("guest-limit")
}
